const PRODUCTION_CHECKOUT_BASE_URL = 'https://pay.vendepay.com'
const PRODUCTION_APP_BASE_URL = 'https://app.vendepay.com'
const LOCAL_CHECKOUT_BASE_URL = 'http://localhost:5174'

function resolveUrl(value: unknown, fallback: string) {
  return typeof value === 'string' && value.trim().length > 0 ? value : fallback
}

function resolveBase(value: unknown, fallback: string) {
  const raw = resolveUrl(value, fallback)
  return raw.endsWith('/') ? raw.slice(0, -1) : raw
}

function currentAppOrigin() {
  if (typeof window === 'undefined' || !window.location.origin) {
    return PRODUCTION_APP_BASE_URL
  }
  return window.location.origin
}

function defaultCheckoutBaseUrl() {
  if (import.meta.env.VITE_CHECKOUT_WEB_URL) {
    return resolveBase(import.meta.env.VITE_CHECKOUT_WEB_URL, LOCAL_CHECKOUT_BASE_URL)
  }
  return import.meta.env.DEV ? LOCAL_CHECKOUT_BASE_URL : PRODUCTION_CHECKOUT_BASE_URL
}

export function checkoutBaseUrl() {
  return resolveBase(import.meta.env.VITE_CHECKOUT_BASE_URL, defaultCheckoutBaseUrl())
}

export function appBaseUrl() {
  return resolveBase(import.meta.env.VITE_APP_BASE_URL, currentAppOrigin())
}

export function upsellScriptUrl() {
  return resolveUrl(import.meta.env.VITE_UPSELL_SCRIPT_URL, `${checkoutBaseUrl()}/upsell.js`)
}

export function checkoutUrl(checkoutId: string) {
  return `${checkoutBaseUrl()}/c/${checkoutId}`
}

export function checkoutOfferUrl(_checkoutId: string, offerId: string) {
  return checkoutUrl(offerId)
}

export function affiliateCheckoutUrl(
  checkoutId: string,
  affiliateId: string,
  tracking: { source?: string; campaign?: string } = {},
) {
  const url = new URL(checkoutUrl(checkoutId))
  url.searchParams.set('ref', affiliateId)
  if (tracking.source?.trim()) {
    url.searchParams.set('utm_source', tracking.source.trim())
  }
  if (tracking.campaign?.trim()) {
    url.searchParams.set('utm_campaign', tracking.campaign.trim())
  }
  return url.toString()
}

export function productUrl(slug: string) {
  return `${checkoutBaseUrl()}/p/${slug}`
}

export function offerUrl(slug: string, offerId: string) {
  return `${checkoutBaseUrl()}/p/${slug}?of=${offerId}`
}

export function affiliateInviteUrl(token: string) {
  return `${appBaseUrl()}/affiliates/invite/${token}`
}

export function affiliateInviteTokenFromUrl(value: string) {
  return /\/affiliates\/invite\/([^/?#]+)/.exec(value.trim())?.[1] ?? ''
}

export function upsellSnippet(offerId: string) {
  return `<script src="${upsellScriptUrl()}" data-offer="${offerId}"></script>`
}
